<template>
  <div>
    <!--begin::Row-->
    <!-- <div class="row">
        <div class="col-lg-12"> -->
            <div class="card card-custom card-stretch gutter-b">
                <!--begin::Header-->
                <div class="card-header border-0">
                    <h3 class="card-title font-weight-bolder text-dark">Verifikasi Lapangan Pemda Kabupaten</h3>
                    <div class="card-toolbar">
                        
                    </div>
                </div>
                <!--end::Header-->
                <!--begin::Body-->
                <div class="card-body pt-0">
                    <!--begin::Item-->
                    <div class="mb-12">
                        <!--begin::Content-->
                        <div>
                          <div class="row">
                            <div class="col-xl-8">
                            </div>
                            <div class="col-xl-4">
                            <div class="form-group row">
                              <label class="col-sm-4 col-form-label">Pilih Provinsi</label>
                                    <!--begin::Input-->
                                    <div class="col-sm-8">            
                                            <b-form-select v-model="selectedprovinsi" @input="getdata()">
                                            <option
                                                v-for="(dataprovinsi, k) in provinsi"
                                                :key="k"
                                                :value="dataprovinsi.id"
                                            >
                                                {{ dataprovinsi.name }}
                                            </option>
                                            </b-form-select>
                                    </div>
                            </div>
                            </div>
                          </div>
                            <div style="overflow-x:auto;">
                                <table id="example" class="table table-striped table-bordered" style="width:100%">
                                  <thead>
                                      <tr>
                                          <th rowspan="2">No</th>
                                          <th rowspan="2">Nama Kabupaten</th>
                                          <th rowspan="2">Nama Surveyor</th>
                                          <th style="text-align:center;" colspan="2">PM PTSP Pemda</th>
                                          <th style="text-align:center;" colspan="2">PM PPB Pemda</th>
                                          <th rowspan="2">Tanggal BA Verifikasi PM PTSP Pemda</th>
                                          <th rowspan="2">Tanggal BA Verifikasi PM PPB Pemda</th>
                                          <th colspan="2" style="text-align:center;">Foto dengan PIC</th>
                                      </tr>
                                      <tr>
                                        <th>Mulai verifikasi lapangan</th>
                                        <th>Selesai verifikasi lapangan</th>
                                        <th>Mulai verifikasi lapangan</th>
                                        <th>Selesai verifikasi lapangan</th>
                                        <th>PTSP</th>
                                        <th>PPB</th>
                                      </tr>
                                  </thead>
                                  <tbody v-if="selectedprovinsi === ''">
                                      <tr v-for="row in dataprovinsi1" :key="row.id">
                                          <td></td>
                                          <td><div style="width:130px">{{row.nama_wilayah}}</div></td>
                                          <td><div style="width:130px">{{format_name(row.name_user)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_mulai)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_selesai)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_mulai)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_selesai)}}</div></td>
                                          <td><div style="width:250px">{{format_date(row.tanggal_bap_verifikasi_pm)}}</div></td>
                                          <td><div style="width:250px">{{format_date(row.tanggal_bap_verifikasi_ppb)}}</div></td>
                                          <td>
                                            <a v-if="row.foto_pm != null" :href="row.foto_pm" target="_blank">
                                                <b-img :src="row.foto_pm" style="width: 100px;" fluid alt="Foto"></b-img>
                                            </a>
                                          </td>
                                          <td>
                                            <a v-if="row.foto_ppb != null" :href="row.foto_ppb" target="_blank">
                                                <b-img :src="row.foto_ppb" style="width: 100px;" fluid alt="Foto"></b-img>
                                            </a>
                                          </td>
                                            <!-- <td></td> -->
                                          <!-- <td>t.nixon@datatables.net</td> -->
                                      </tr>
                                  </tbody>
                                  <tbody v-else>
                                      <tr v-for="row in dataprovinsi2" :key="row.id">
                                          <td></td>
                                          <td><div style="width:130px">{{row.nama_wilayah}}</div></td>
                                          <td><div style="width:130px">{{format_name(row.name_user)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_mulai)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_selesai)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_mulai)}}</div></td>
                                          <td><div style="width:180px">{{format_date(row.tanggal_selesai)}}</div></td>
                                          <td><div style="width:250px">{{format_date(row.tanggal_bap_verifikasi_pm)}}</div></td>
                                          <td><div style="width:250px">{{format_date(row.tanggal_bap_verifikasi_ppb)}}</div></td>
                                          <td>
                                            <a v-if="row.foto_pm != null" :href="row.foto_pm" target="_blank">
                                                <b-img :src="row.foto_pm" style="width: 100px;" fluid alt="Foto"></b-img>
                                            </a>
                                          </td>
                                          <td>
                                            <a v-if="row.foto_ppb != null" :href="row.foto_ppb" target="_blank">
                                                <b-img :src="row.foto_ppb" style="width: 100px;" fluid alt="Foto"></b-img>
                                            </a>
                                          </td>
                                            <!-- <td></td> -->
                                          <!-- <td>t.nixon@datatables.net</td> -->
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                        </div>
                        <!--end::Content-->
                    </div>
                    <!--end::Item-->
                </div>
                <!--end: Card Body-->
            </div>
        </div>
    <!-- </div>
  </div> -->
</template>
<style>
  div.messages {
  /* background-color: lightblue; */
  /* width: 110px; */
  height: 500px;
  overflow: auto;
}
tfoot input {
        width: 100%;
        padding: 3px;
        box-sizing: border-box;
}
</style>
<style lang="">
  
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from 'axios';
import moment from 'moment'
export default {
  data() {
      return {
        test:'hai',
        url: localStorage.getItem('baseapi'),
        token: localStorage.getItem('id_token'),
        totskor1:[],
        totskor2:[],
        search: '',
        selectedprovinsi:'',
        provinsi:'',
        dataprovinsi1:[],
        dataprovinsi2:[],
        headers: [
            {
            text: 'Nama',
            align: 'left',
            sortable: false,
            value: 'name',
            },
            { text: 'Ket', value: 'ket' },
            { text: 'Icon', value: 'icon' },
            { text: 'Aksi', value: '' },
            
        ],
      }
  },
  components: {
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Verifikasi Lapangan" }]);
    this.getprovinsi()
    this.getdata()
    
  },
  methods: {
    getprovinsi(){
        axios.get(this.url+'/provinsis', {
              headers: {
                  'xth': this.token
              }
            }).then(response => {
            this.provinsi = response.data;
            this.provinsi.push({id:'', name:'Semua Provinsi',created_at:null,updated_at:null})
        });
      },
    getdata(){
      $('#example').DataTable().destroy();
      let idprovinsi = this.selectedprovinsi;
            this.loaddata(idprovinsi)
    },
    loaddata(idprovinsi){
      if (idprovinsi ==='') {
        this.dataprovinsi1 = null;
        axios.get(this.url+`/penempatan/surveyor/kabupaten`, {
              headers: {
                  'xth': this.token
              }
            })
        .then(response => {
            this.totskor1 = response.data.data;
            this.dataprovinsi1 = this.totskor1;
            this.initDatatable1();
        }).catch(error=>{
            return error
            });
      } else {
        this.dataprovinsi2 = null;
        axios.get(this.url+`/penempatan/surveyor/kabupaten?filter=kode_wilayah,like,${idprovinsi}%`, {
              headers: {
                  'xth': this.token
              }
            })
        .then(response => {
            this.totskor2 = response.data.data;
            this.dataprovinsi2 = this.totskor2;
            console.log(this.dataprovinsi2)
            this.initDatatable2();
        }).catch(error=>{
            return error
            });
      }
    },
    initDatatable1() {
      setTimeout(() => {
        var t =  $('#example').DataTable({
            "pagingType": "full_numbers",
            "language": {
                "info": "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
                "paginate": {
                    "first":      "Awal",
                    "last":       "Akhir",
                    "next":       "Selanjutnya",
                    "previous":   "Sebelumnya"
                },
            },
            dom: 'Bfrtip',
            "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                //debugger;
                var index = iDisplayIndexFull + 1;
                $("td:first", nRow).html(index);
                return nRow;
              },
              columnDefs: [{
                targets: 0,
                render: function(data, type, row, meta) {
                console.log(meta.row);
                console.log(type == 'export'? meta.row : data);
                  return type == 'export'? meta.row + 1 : data;
                }
              }],
              buttons: [
                {
                  extend: 'excel',
                    text : 'Excel',
                    title: 'VERIFIKASI LAPANGAN PEMDA KABUPATEN KEMENTERIAN INVESTASI/BKPM',
                    exportOptions: {
                        columns: [ 0, 1, 2, 3, 4, 5, 6, 7, 8],
                        orthogonal: 'export',
                    },
                    filename: function(){
                        var today = new Date();
                        // var n = d.getTime();
                        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                        
                        return 'VERIFIKASI LAPANGAN PEMDA KABUPATEN ' + date;
                    },
                },
                {
                  extend: 'pdf',
                    text : 'PDF',
                    orientation: 'landscape',
                    title: 'VERIFIKASI LAPANGAN PEMDA KABUPATEN KEMENTERIAN INVESTASI/BKPM',
                    exportOptions: {
                        columns: [ 0, 1, 2, 3, 4, 5, 6, 7, 8],
                        orthogonal: 'export',
                    },
                    filename: function(){
                        var today = new Date();
                        // var n = d.getTime();
                        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                        
                        return 'VERIFIKASI LAPANGAN PEMDA KABUPATEN ' + date;
                    },
                }
            ],
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            order: [[3, 'asc']],
            responsive: true,
            destroy: true,
            retrieve: true,
            autoFill: true,
            // colReorder: true,

        });
        t.on( 'order.dt search.dt', function () {
        t.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
            cell.innerHTML = i+1;
        } );
        } ).draw();
        }, 300);
    },
    initDatatable2() {
      setTimeout(() => {
        var t =  $('#example').DataTable({
            "pagingType": "full_numbers",
            "language": {
                "info": "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
                "paginate": {
                    "first":      "Awal",
                    "last":       "Akhir",
                    "next":       "Selanjutnya",
                    "previous":   "Sebelumnya"
                },
            },
            dom: 'Bfrtip',
            "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                //debugger;
                var index = iDisplayIndexFull + 1;
                $("td:first", nRow).html(index);
                return nRow;
              },
              columnDefs: [{
                targets: 0,
                render: function(data, type, row, meta) {
                console.log(meta.row);
                console.log(type == 'export'? meta.row : data);
                  return type == 'export'? meta.row + 1 : data;
                }
              }],
              buttons: [
                {
                  extend: 'excel',
                    text : 'Excel',
                    title: 'VERIFIKASI LAPANGAN PEMDA KABUPATEN KEMENTERIAN INVESTASI/BKPM',
                    exportOptions: {
                        columns: [ 0, 1, 2, 3, 4, 5, 6, 7, 8],
                        orthogonal: 'export',
                    },
                    filename: function(){
                        var today = new Date();
                        // var n = d.getTime();
                        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                        
                        return 'VERIFIKASI LAPANGAN PEMDA KABUPATEN ' + date;
                    },
                },
                {
                  extend: 'pdf',
                    text : 'PDF',
                    orientation: 'landscape',
                    title : 'VERIFIKASI LAPANGAN PEMDA KABUPATEN KEMENTERIAN INVESTASI/BKPM',
                    exportOptions: {
                        columns: [ 0, 1, 2, 3, 4, 5, 6, 7, 8],
                        orthogonal: 'export',
                    },
                    filename: function(){
                        var today = new Date();
                        // var n = d.getTime();
                        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                        
                        return 'VERIFIKASI LAPANGAN PEMDA KABUPATEN ' + date;
                    },
                }
            ],
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            order: [[3, 'asc']],
            responsive: true,
            destroy: true,
            retrieve: true,
            autoFill: true,
            // colReorder: true,

        });
        t.on( 'order.dt search.dt', function () {
        t.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
            cell.innerHTML = i+1;
        } );
        } ).draw();
        }, 300);
    },
    format_date(value){
         if (value) {
           return moment(String(value)).format('DD-MM-YYYY')
          }
    },
    format_name(value){
      return String(value).replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    },
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    }
  },
};
</script>
